import { tv, type VariantProps } from 'tailwind-variants';
export type AtMediaVariants = VariantProps<typeof atMediaVariants>;

const atMediaVariants = tv({
  base: 'object-cover',
  slots: {
    container: 'relative w-full',
  },
  variants: {
    aspectRatio: {
      auto: {
        container: 'aspect-auto h-full',
      },
      '16/9': {
        container: 'aspect-video',
      },
      '3/2': {
        container: 'aspect-[3/2]',
      },
      '1/1': {
        container: 'aspect-square',
      },
      '4/3': {
        container: 'aspect-[4/3]',
      },
      '2/3': {
        container: 'aspect-[2/3]',
      },
      '21/9': {
        container: 'aspect-[21/9]',
      },
      '9/16': {
        container: 'aspect-[9/16]',
      },
    },
    rounded: {
      none: 'rounded-none',
      sm: 'rounded-sm',
      md: 'rounded-md',
      lg: 'rounded-lg',
      xl: 'rounded-xl',
      '2xl': 'rounded-2xl',
      '3xl': 'rounded-3xl',
    },
    intent: {
      default: {
        container: '',
        base: '',
      },
      background: {
        container: '!absolute z-0 left-0 bottom-0',
        base: '',
      },
    },
    position: {
      left: {
        container: '',
        base: 'object-left',
      },
      center: {
        container: '',
        base: 'object-center',
      },
      right: {
        container: '',
        base: 'object-right',
      },
    },
  },
  compoundVariants: [],
});

export default atMediaVariants;
